var IPPODO = IPPODO || {}

/**
 * TODO: チェックアウトで選択するセレクトボックスの拡張
 * Developer: kanehori
 * 2023/06
 */
IPPODO['AddressSelectorCustom'] = {
  init() {
    this.element = {
      customerAddresses: '[data-wl-customer-addresses]',
      addressSelector: '[data-address-selector]',
    };
    this.customerAddresses = document.querySelector(this.element.customerAddresses);
    this.addressSelector = document.querySelector(this.element.addressSelector);
    this.getAddress = this.jsonTry(this.customerAddresses.textContent);
    if (this.getAddress && this.addressSelector) {
      this.setAddressSelector();
    }
  },
  jsonTry(content) {
    try {
      JSON.parse(content);
    } catch {
      console.error('予期せぬ値が含まれました');
      return false;
    }
    return JSON.parse(content);
  },
  setAddressSelector() {
    this.addressSelector.innerHTML = '';
    for (address of this.getAddress) {
      this.addressSelector.innerHTML += `<option data-properties='${JSON.stringify(address.address)}' value="${address.address.id
        }" ${address.address.default == true ? 'selected' : ''}>${address.list_name}</option>`;
    }
    this.addressSelector.innerHTML += '<option value="">新しい住所を使用する</option>';
  },
};

/*
 * TODO: 請求先の国を日本のみにする対応
 */
IPPODO['removeCountry'] = {
  init(shippingFlg) {
    this.elements = {
      paymentForm: '[data-payment-form]',
      countrySelector: 'select[name="checkout[billing_address][country]"]',
      differentBillingAddressTrue: 'input#checkout_different_billing_address_true[name="checkout[different_billing_address]"]',
      differentBillingAddressFalse: 'input#checkout_different_billing_address_false[name="checkout[different_billing_address]"]',
      addressDifferent: '#section--billing-address__different',
    }
    this.form = document.querySelector(this.elements.paymentForm)
    if (this.form && !shippingFlg) {
      this.differentBillingAddressOnly()
    }
    if (this.form) {
      this.selector = this.form.querySelector(this.elements.countrySelector)
      this.selector.innerHTML = '<option data-code="JP" data-pure-numeric-postal-code="false" selected="selected" value="Japan">日本</option>'
    }
  },
  differentBillingAddressOnly() {
    const differentBillingAddressTrue = this.form.querySelector(this.elements.differentBillingAddressTrue)
    const differentBillingAddressFalse = this.form.querySelector(this.elements.differentBillingAddressFalse)
    const addressDifferent = this.form.querySelector(this.elements.addressDifferent)
    addressDifferent.classList.remove('hidden')
    const disableds = this.form.querySelectorAll('[disabled]')
    for (disabled of disableds) {
      disabled.disabled = false
    }
    differentBillingAddressTrue.checked = true
    differentBillingAddressFalse.disabled = true
  }
}
/**
 * TODO: 表書きのテキストを修正
 * Developer: kanehori
 * 2023/06
 */
IPPODO['noshiTextReplace'] = {
  init() {
    const omotegaki = document.querySelector('[name="noshi-content"]')
    const name = document.querySelector('[name="noshi-recipient"]')
    this.replaceEvt(omotegaki)
    this.replaceEvt(name)
  },
  stringMap() {
    return {
      'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
      'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
      'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
      'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
      'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
      'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
      'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
      'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
      'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
      'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
      'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
      'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
      'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
      'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
      'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
      'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
      'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
      'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
      '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・',
      'a': 'ａ', 'b': 'ｂ', 'c': 'ｃ', 'd': 'ｄ', 'e': 'ｅ', 'f': 'ｆ', 'g': 'ｇ',
      'h': 'ｈ', 'i': 'ｉ', 'j': 'ｊ', 'k': 'ｋ', 'l': 'ｌ', 'm': 'ｍ', 'n': 'ｎ',
      'o': 'ｏ', 'p': 'ｐ', 'q': 'ｑ', 'r': 'ｒ', 's': 'ｓ', 't': 'ｔ', 'u': 'ｕ',
      'v': 'ｖ', 'w': 'ｗ', 'x': 'ｘ', 'y': 'ｙ', 'z': 'ｚ',
      'A': 'Ａ', 'B': 'Ｂ', 'C': 'Ｃ', 'D': 'Ｄ', 'E': 'Ｅ', 'F': 'Ｆ', 'G': 'Ｇ',
      'H': 'Ｈ', 'I': 'Ｉ', 'J': 'Ｊ', 'K': 'Ｋ', 'L': 'Ｌ', 'M': 'Ｍ', 'N': 'Ｎ',
      'O': 'Ｏ', 'P': 'Ｐ', 'Q': 'Ｑ', 'R': 'Ｒ', 'S': 'Ｓ', 'T': 'Ｔ', 'U': 'Ｕ',
      'V': 'Ｖ', 'W': 'Ｗ', 'X': 'Ｘ', 'Y': 'Ｙ', 'Z': 'Ｚ',
      '0': '０', '1': '１', '2': '２', '3': '３', '4': '４', '5': '５', '6': '６', '7': '７', '8': '８', '9': '９',
      ' ': '　', '-': 'ー', ':': '：', '@': '＠', '[': '［', '~': '〜', ']': '］',
      '!': '！', '#': '＃', '$': '＄', '%': '％', '&': '＆', '(': '（', ')': '）', '*': '＊',
      '+': '＋', ':': '：', ';': '；', '-': 'ー', '.': '．', '/': '／', '<': '＜', '=': '＝', '>': '＞'
      , '?': '？', '@': '＠', '[': '［', '\\': '＼', ']': '］', '^': '＾', '_': ' ＿', '`': '｀'
      , '{': '｛', '|': '｜', '}': '｝', '~': '〜'
    }
  },
  replaceEvt(elm) {
    const eventTypes = ['focusout', 'blur', 'compositionend', 'change']
    
      if(!elm || elm.length <= 0 ){
        return
      }
      if(elm != null) {
        eventTypes.forEach((eventType) => {
          elm.addEventListener(eventType, (e) => {
            e.target.value = e.target.value.replaceAll(',', '，')
            e.target.value = e.target.value.replaceAll('"', '＂')
            e.target.value = e.target.value.replaceAll("'", '＇')

            e.target.value = e.target.value.replaceAll("-", 'ー')
            e.target.value = e.target.value.replaceAll(":", '：')
            e.target.value = e.target.value.replaceAll("@", '＠')
            e.target.value = e.target.value.replaceAll("[", '［')
            e.target.value = e.target.value.replaceAll("~", '〜')
            e.target.value = e.target.value.replaceAll("]", '］')
            e.target.value = e.target.value.replaceAll(" ", '　')
            e.target.value = e.target.value.replaceAll("'", '＇')
            this.mapping = this.stringMap()
            let reg = new RegExp('[ｱ-ﾝ]|[0-9]|[a-z]|[A-Z]|[ -/:-@\[-~]', 'g');
            for (let t of e.target.value) {
              if (t.match(reg)) {
                e.target.value = e.target.value.replaceAll(t, this.mapping[t])
              }
            }
            if (e.target.value.length >= 15) {
              e.target.value = e.target.value.slice(0, 15)
            }
          })
      })
    }
  }
}

